const BASE64URL_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

/**
 * Generates a short, URL-safe random ID (12 characters, Base64URL alphabet).
 * Uses crypto.randomUUID when available (HTTPS), falls back to crypto.getRandomValues (HTTP).
 */
export function generateShortId(): string {
    const uuid = crypto.randomUUID?.();
    if (uuid) {
        return uuid.replace(/-/g, '').slice(0, 12);
    }

    return Array.from(
        crypto.getRandomValues(new Uint8Array(12)),
        b => BASE64URL_ALPHABET[b & 63]
    ).join('');
}
